var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('NeoButton',{attrs:{"label":_vm.$t(`${_vm.label}`),"variant":_vm.variant,"no-shadow":_vm.noShadow},nativeOn:{"click":function($event){return _vm.toggleWalletConnectModal.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }